import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import User from "../../../../assets/images/CT/profile.png";

const CTStart = (props) => {
  const playingParams = _.get(props, "paramsReducer.gameObj.2_playing");
  const { colours } = props;
  return (
    <>
      <div className="ct-user">
        <img
          src={props?.player?.profile_image}
          alt="user"
          className={`user ${colours[props?.player?.player_id - 1]}`}
        />
      </div>
      <div className="start-content">
        <p>It’s {props?.player?.display_name}’s Turn</p>
        <h4>{playingParams?.roll_dice_to_start}</h4>
      </div>
    </>
  );
};
const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer,
});
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(CTStart);
